<template>
  <div class="contact-me-page">
    <!-- Page banner -->
    <Banner main-title="contact me"
            main-text="Email"
            italic-text="and social media"
            typewriter-id="ContactMe"
            banner-class="banner-blue-light"
            :typewriter-delay="150"
            :has-scroll-indicator="true"
            class="left"/>

    <div class="page-content-wrapper">
      <!-- Email -->
      <h2 class="section-title-small">Email address</h2>
      <a class="link-blue-light email-link" href="mailto:nikos@pertsilis.com">nikos@pertsilis.com</a>
    </div>

    <!-- LinkedIn -->
    <!--    <h2 class="section-title-small">LinkedIn</h2>-->
    <!--    <a class="" href="mailto:nikos@pertsilis.com">nikos@pertsilis.com</a>-->
  </div>
</template>

<script>
import Banner from "@/components/v2/Banner";
import {userVisitedAboutMe} from "@/setup/firebase/firebaseAnalytics";
import {STATIC_LINKS} from "@/utils/data/links";

export default {
  name: "ContactMe",
  components: {
    Banner
  },
  data: () => ({
    STATIC_LINKS,
  }),
  mounted() {
    userVisitedAboutMe();
  },
  metaInfo: {
    title: 'Pertsilis',
    titleTemplate: '%s | About me.',
    meta: [{
      name: 'description',
      content: 'Front-end web developer in the Netherlands, with experience in building web applications and PWAs, using Vue.js and JavaScript.'
    }]
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";
@import "~@/assets/css/base.links";

.contact-me-page {
  padding-bottom: 50px;
}

.page-content-wrapper {
  padding: 0 20px;
}

/** Other **/
.section-title-small {
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 5px;
  margin-top: 60px;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.email-link {
  font-size: 16px;
}

@media screen and (min-width: $screen-md) {
  .contact-me-page {
    padding-bottom: 75px;
  }

  .page-content-wrapper {
    padding: 0 10%;
  }

  /** Other **/
  .section-title-small {
    font-size: 20px;
  }

  .email-link {
    font-size: 18px;
  }
}
</style>
